export const ACCESSIBILITY_INFO_HELPER = `
  Any accessibility requirements you chose to share with us will be made
  available to the production team and website staff. Any information you
  provide will be deleted shortly after the event. We cannot guarantee
  that your requirements can be met, though a member of the team will be
  in touch to discuss your requirements if needed.
`;
export const ACCESSIBILITY_INFO_HELPER_EMAIL =
  ACCESSIBILITY_INFO_HELPER +
  ' If you have any questions, or have more complex needs than can be summarised here, please email <a href="mailto:accessibility@uobtheatre.com" class="underline">accessibility@uobtheatre.com</a>';
